import React, { useRef, useState } from "react";
import * as S from "./ModalUserAiNavigator.style";
import * as P from "../../../../../utils/pipes";
import { useTranslation } from "react-i18next";
import ZaiaImage from "../../../../zaiaComponents/zaiaImage";
import ProcessName from "../../../shared/processName";
import Popup from "reactjs-popup";
import { Actions } from "../../../../../utils/actionsIds";

// Routes
import { Routes } from "../../../../../utils/constants";
import { useNavigate } from "react-router-dom";
import { useStateValue } from "../../../../../contextAPI/StateProvider";
import { useEffect } from "react";
import useRecordNavigation from "../../../../../hooks/useRecordNavigation";
import Modal from "../../../../../utils/modal";
import ModalAddOutcomesEvent from "../../../shared/modals/modalAddOutcomesEvent";
import ModalAddEventCalendar from "../../../agenda/components/modalAddEventCalendar";
import useAssignSelectPatient from "../../../../../hooks/useAssignSelectPatient";
import { QUERY_GET_USERS_BY_USER_ID } from "../../../../../graphql/queries/User";
import { useQuery } from "@apollo/client";
import ZaiaReaction from "../../../../zaiaComponents/zaiaReaction";
import ModalChangeProgramStatus from "../../../shared/modals/modalChangeProgramStatus";
import PdfPatientInfo from "../../../patients/components/dashboardPatient/components/pdfPatientInfo/PdfPatientInfo";
import UserAINavigatorBoxes from "./userAINavigatorView";
import NewUserAINavigatorBoxes from "./newUserAINavigatorBoxes";
import FlorenzButton from "../../../../florenzComponents/florenzButton";
import UserGeneralNote from "./userGeneralNote/UserGeneralNote";
import ModalPathologies from "../modalPatologies/ModalPathologies";
import { PatientNamePopup } from "../../../followUp/FollowUp.style";
import PatientInfo from "../patientInfo";

// Assets
const logoZaiaLoading = `${process.env.REACT_APP_STORAGE_ZAIA_RESOURCES}/zaiaReactions/singularity-health-loader.svg`;
const logoZaiaAlert = `${process.env.REACT_APP_STORAGE_ZAIA_RESOURCES}/zaiaReactions/reaction-error-data.svg`;

function ModalUserAiNavigator({ 
  setSelectedPatient,
  selectedPatient,
  updateActived
}) {

  const {t, i18n: { language }} = useTranslation("global");
  const navigate = useNavigate();
  const { AINAVIGATOR, DASHBOARD, AGENDA } = Routes;
  const [, dispatch] = useStateValue();
  const { selectPatient, removePatient } = useAssignSelectPatient();
  const { recordAction } = useRecordNavigation();
  const [addOutcomesEvent, setAddOutcomesEvent] = useState(false);
  const [addCalendarEvent, setAddCalendarEvent] = useState(false);
  const [changeProgramStatus, setChangeProgramStatus] = useState(false);
  const [managePathologies, setManagePathologies] = useState(false);
  const programList = useRef();
  const [cantidadElementosQueCaben, setCantidadElementosQueCaben] = useState(0);
  const [showInfo, setShowInfo] = useState(false);
  const [editInfo, setEditInfo] = useState(false);

  useEffect(() => {
    if(updateActived) {
      setShowInfo(true);
    }
  }, [updateActived])

  useEffect(() => {
    const updateWidth = () => {
      calcElemetsQuantity();
    };    
  
    updateWidth(); // Get initial width
    window.addEventListener("resize", updateWidth);
  
    return () => window.removeEventListener("resize", updateWidth);
  }, []);


  useEffect(() => {
    calcElemetsQuantity()
  }, [programList.current]);

  const calcElemetsQuantity = () => {
    const contenedor = programList.current;

    if (contenedor) {
      const elementos = Array.from(contenedor.children);  // Obtener todos los hijos
      let contenedorWidth;

      if(cantidadElementosQueCaben !== 0 && cantidadElementosQueCaben === elementos.length) {
        contenedorWidth = contenedor.offsetWidth - 100;     // Ancho del contenedor
      } else {
        contenedorWidth = contenedor.offsetWidth - 165;     // Ancho del contenedor
      }
      let widthActual = 0;
      let elementosQueCaben = 0;

      // Calcular cuántos elementos caben
      for (let elemento of elementos) {
          const elementoWidth = elemento.offsetWidth;  // Obtener ancho del elemento

          if (widthActual + elementoWidth <= contenedorWidth) {
              widthActual += elementoWidth;
              elementosQueCaben++;
          } else {
              break;
          }
      }

      setCantidadElementosQueCaben(elementosQueCaben);
    }
  }  

  const {data: userData, loading: userDataLoading, error: userDataError} = useQuery(QUERY_GET_USERS_BY_USER_ID, {
    variables: {
      patientId: selectedPatient.id
    },
    skip: !selectedPatient?.id, 
    fetchPolicy: 'cache-and-network'
  });     

  useEffect(() => {
    function handleKeyDown(e) {
      if (e.keyCode === 27)  {
        closeModal();
      }
    }

    document.addEventListener('keydown', handleKeyDown);

    // Don't forget to clean up
    return function cleanup() {
      document.removeEventListener('keydown', handleKeyDown);
    }
  }, []);  

  useEffect(() => {
    selectPatient(userData?.user[0].id);
  }, [userData])

  const closeModal = () => {
    removePatient();
    setSelectedPatient(null);
  }

  const openFlorence = () => {
    closeModal();
    dispatch({
      type: "SET_FLORENCE_VIEW",
      florenceView: 2,
    });
    dispatch({
      type: "SET_FLORENCE_PATIENT",
      florencePatient: userData?.user[0],
    });
    dispatch({
      type: "SET_FLORENCE_ACTIVE",
      florenceActive: userData?.user[0],
    });
  }
  
  const openNotes = async () => {
    await dispatch({
      type: "SET_ANCHORED_VIEW_ACTIVE",
      anchoredViewActived: 1,
    });
    await dispatch({
      type: "SET_NOTES_PATIENT",
      notesPatient: userData?.user[0],
    });
    closeModal();
  }

  const frequencyHours = (userToProcess) => {
    if(userToProcess.processStage?.frequencyType === "days") {
      return (userToProcess.processStage?.frequency * 24) 
    } else {
      return userToProcess.processStage?.frequency
    }
  } 

  const followUpInfo = userData?.user[0]?.userToProcesses?.map((userToProcess) => {
    return {
      id: userToProcess.id,
      processId: userToProcess.process?.id,
      processName: P.dataTranslation(userToProcess.process?.processName, language),
      stageId: userToProcess.stageId,
      lastFollowingDate: userToProcess.userToProcessHistories?.length > 0 ? new Date(userToProcess.userToProcessHistories[0].created_at) : null,
      nextFollowingDate: new Date(userToProcess.nextUpdate),
      futureFollowingDate: new Date(new Date(userToProcess.nextUpdate).setHours(frequencyHours(userToProcess),0,0,0))
    }
  })

  const isTodayBirthday = (birthdate) => {
    const today = new Date();
    const birthDate = new Date(birthdate);
       
    return today.getDate() === birthDate.getDate() && today.getMonth() === birthDate.getMonth();
  }  

  const findFirstComment = (userToProcess) => {
    const histories = userToProcess?.userToProcessHistories ?? [];

    for (const item of histories) {
      const comment = item?.processStage?.groupStage?.comment;
      if (comment) {
        return comment;
      }
    }

    return null;
  }

  const findFirstState = (userToProcess) => {
    const histories = userToProcess?.userToProcessHistories ?? [];

    for (const item of histories) {
      const comment = item?.processStage?.stageName;
      // if (comment && item?.processStage?.id !== "completo_ciclos_tratamiento_programados") {
        return comment;
      // }
    }

    return null;
  }

  if(userDataLoading) 
    return (
      <S.ModalUserAiNavigator>
        <div className="modal-background" onClick={() => closeModal()}>
        </div>
        <div className="modal-container">
          <div className="modal-container__reaction">
            <ZaiaReaction
              widthimg="150px"
              zaiaImg={logoZaiaLoading}
            /> 
          </div>
        </div>
      </S.ModalUserAiNavigator>
    )
    
    if(userDataError) 
      return (
        <S.ModalUserAiNavigator>
          <div className="modal-background" onClick={() => closeModal()}>
          </div>
          <div className="modal-container">
            <div className="modal-container__reaction">
              <ZaiaReaction
                zaiaImg={logoZaiaAlert}
                widthimg="200px"
                text={t("globally.genericError")}
                sizeText="18px"
                widthText="290px"
              />
            </div>
          </div>
        </S.ModalUserAiNavigator>
      )      

  return (
    <S.ModalUserAiNavigator>
      <div className="modal-background" onClick={() => closeModal()}>
      </div>
      <div className="modal-container">
        <Modal open={addOutcomesEvent}>
          <ModalAddOutcomesEvent
            setCreateEventActive={setAddOutcomesEvent}
            patientID={userData?.user[0].id}
          />
        </Modal>
        <Modal open={addCalendarEvent}>
          <ModalAddEventCalendar
            event={null}
            setCardEventSelected={null}
            setCreateEventCalendarActive={setAddCalendarEvent}
            patientID={userData?.user[0].id}
          />
        </Modal>
        <Modal open={changeProgramStatus}>
          <ModalChangeProgramStatus
            setChangeProgramStatus={setChangeProgramStatus}
            patient={userData?.user[0]}
          />
        </Modal>
        <Modal open={managePathologies}>
          <ModalPathologies
            setModalActive={setManagePathologies}
            patientInfo={userData?.user[0]}
          />
        </Modal>
        <div className="content">
          <div className="content__left">
            <div className="patient-image">
              <div className="patient-image__border"></div>
              <img
                className="patient-image__img"
                src={userData?.user[0].picture}
                alt={userData?.user[0].name}
              />
              <img
                className="patient-image__img-shadow"
                src={userData?.user[0].picture}
                alt={userData?.user[0].name}
              />
            </div>
            <div className="patient-principal-info">
              <div className="patient-name">
                {userData?.user[0].name} {userData?.user[0].lastname}
              </div>
              <div className="patient-info">
                {
                  userData?.user[0]?.birthdate &&
                  <>
                    <div className="patient-info__years">  
                      {P.getAge(userData?.user[0]?.birthdate)} {t("aiNavigator.outcomes.yearsOld")}
                    </div>
                    <div className="patient-info__separator"></div>
                  </>
                }
                <div className="patient-info__id-number">
                  {userData?.user[0].enDocumentType?.comment.code} {userData?.user[0].documentNumber}
                </div>
              </div>
            </div>
            <div className="patient-general-note">
              <UserGeneralNote 
                patient={selectedPatient}
              />
            </div>
          </div>
          <div className="content__right">
            {
              showInfo &&
              <PatientInfo
                setShowInfo={setShowInfo}
                selectedPatient={userData?.user[0]}
                updateActived={updateActived}
              />
            }
            {
              !showInfo &&
              <div className="patient-ai-navigator-info">
                <div className="patient-card">
                  <div className="patient-card__left">
                    <div className="patient-contact">
                      <div className="title-space">
                        <div className="title-space__text">
                          {t("aiNavigator.filters.contact")}
                        </div>
                        <div className="title-space__icon">
                          <i className="icon zaia-i-phone"></i>
                        </div>
                      </div>
                      {
                        (userData?.user[0].phoneCountry?.phonecode && userData?.user[0].phone) &&
                        <div className="contact-item">
                          <div className="contact-item__title">
                            {t("globally.patient")}
                          </div>
                          <div className="contact-item__value">
                            {
                              userData?.user[0].phoneCountry?.phonecode
                              ? "+" + userData?.user[0].phoneCountry?.phonecode + " "
                              : ""                      
                            } {userData?.user[0].phone}
                          </div>
                        </div>
                      }
                      {
                        (userData?.user[0].carerPhoneCountry && userData?.user[0].phoneCarer) &&
                        <div className="contact-item">
                          <div className="contact-item__title">
                            {t("globally.caregiver")}
                          </div>
                          <div className="contact-item__value">
                            {
                              userData?.user[0].carerPhoneCountry
                              ? "+" + userData?.user[0].carerPhoneCountry?.phonecode + " "
                              : ""
                            } {userData?.user[0].phoneCarer}
                          </div>
                        </div>
                      }
                      <div className="contact-item">
                        <div className="contact-item__title">
                          {t("globally.email")}
                        </div>
                        <Popup
                          trigger={() => (
                            <div className="contact-item__value">
                              {userData?.user[0].email}
                            </div>
                          )}
                          on={["hover"]}
                          position="top center" 
                        >
                          {() => (
                            <PatientNamePopup>
                              {userData?.user[0].email}
                            </PatientNamePopup> 
                          )}
                        </Popup>
                      </div> 
                      {
                        userData?.user[0].birthdate &&
                        <div className="contact-item">
                          <div className="contact-item__title">
                            {t("globally.birthDate")} <b>{P.longDateUTC(userData?.user[0].birthdate, t, language)}</b>
                          </div>
                          { 
                            isTodayBirthday() &&
                            <div className="contact-item__birthdate-alert">
                              <div className="contact-item__birthdate-alert-text">
                                {t("globally.birthdayToday")}   
                              </div>
                              <div className="contact-item__birthdate-alert-icon">🎂</div>
                            </div>
                          }
                        </div>                 
                      }
                    </div>
                  </div>
                  <div className="patient-card__right">
                    <div className="patient-programs">
                      <div className="title-space">
                        <div className="title-space__text">
                          {t("globally.programmeInformation")}
                        </div>
                        <div className="title-space__management">
                          <div className="management-link"
                            onClick={() => {
                              recordAction(Actions.AINAVIGATOR_MODAL.CHANGE_PROGRAM_STATUS);
                              setChangeProgramStatus(true);
                            }}
                          >
                            {t("globally.manage")}
                          </div>
                        </div>
                      </div>
                      <div className="patient-programs__list">
                        {/* <div className="header-list">
                          <div className="title-header">{t("globally.program")}</div>
                          <div className="title-header">{t("globally.status")}</div>
                        </div> */}
                        <div className="list">
                          {
                            userData?.user[0]?.userToProcesses?.map((userToProcess, index) => {                                       

                              return (
                                <div className="program-item"
                                  key={userToProcess.id}
                                >
                                  <div className="program-item__name">
                                    {P.dataTranslation(userToProcess.process?.processName, language)}
                                  </div>
                                  <div className="program-item__status">
                                    {
                                      userToProcess.processStage?.groupStage &&
                                      `${P.dataTranslation(userToProcess.processStage?.groupStage.comment, language)} - `
                                    }
                                    {
                                      P.dataTranslation(userToProcess.processStage?.stageName, language)
                                      + ` ${userToProcess.processStage?.incremental ? userToProcess.stageExtraInfo : ""}`
                                    }
                                    {
                                      // userToProcess.processStage?.id === "completo_ciclos_tratamiento_programados" && 
                                      (findFirstComment(userToProcess) || findFirstState(userToProcess)) &&
                                      ` (${P.dataTranslation(
                                        findFirstComment(userToProcess)
                                        ? findFirstComment(userToProcess)
                                        : findFirstState(userToProcess)
                                      , language)})`
                                    }
                                  </div>
                                </div>
                              )
                            })
                          }
                        </div>
                      </div>
                    </div>
                    <div className="lists-separator"></div>
                    <div className="patient-programs">
                      <div className="title-space">
                        <div className="title-space__text">
                          {t("globally.pathologiesInformation")}
                        </div>
                        <div className="title-space__management">
                          <div className="management-link"
                            onClick={() => {
                              // recordAction(Actions.AINAVIGATOR_MODAL.CHANGE_PROGRAM_STATUS);
                              setManagePathologies(true);
                            }}
                          >
                            {t("globally.manage")}
                          </div>
                        </div>
                      </div>
                      <div className="patient-programs__list">
                        {/* <div className="header-list">
                          <div className="title-header">{t("globally.program")}</div>
                          <div className="title-header">{t("globally.status")}</div>
                        </div> */}
                        <div className="list">
                          {
                            userData?.user[0]?.userToPatologies?.map((pathology, index) => {

                              return (
                                <div className="program-item"
                                  key={pathology.id}
                                >
                                  <div className="program-item__name">
                                      {P.dataTranslation(pathology.typePatologyVal.name, language)}
                                  </div>
                                </div>
                              )
                            })
                          }
                        </div>
                      </div>
                    </div>
                    {/* <div className="manage-status">
                      <FlorenzButton
                        typeStyle={"secondaryWhite"}
                        size="s"
                        icon="zaia-i-refresh"
                        text={t("changeOfStatus.title")}
                        widthComplete={true}
                        onClick={() => {
                          recordAction(Actions.AINAVIGATOR_MODAL.CHANGE_PROGRAM_STATUS);
                          setChangeProgramStatus(true);
                        }}
                      />
                    </div> */}
                  </div>
                </div>
                <div className="user-ainavigator-boxes">
                  <NewUserAINavigatorBoxes
                    patient={selectedPatient}
                    closeModal={closeModal}
                    followUpInfo={followUpInfo}
                  />            
                </div>
              </div>
            }
          </div>
        </div>
        <div className="footer">
          <div className="footer__left">
            <FlorenzButton
              typeStyle={"secondaryWhite"}
              size="s"
              text={t("globally.close")}
              onClick={() => {
                closeModal()
                recordAction(Actions.AINAVIGATOR_MODAL.CLOSE);
              }}
            />
          </div>
          <div className="footer__right">
            <div className="button-container">
              {
                !showInfo &&
                <FlorenzButton
                  typeStyle={"secondaryWhite"}
                  size="s"
                  text={t("notes.addNote")}
                  icon={"zaia-i-note"}
                  iconSize={"11px"}
                  onClick={
                    () => {
                      recordAction(Actions.AINAVIGATOR_MODAL.GO_NOTES);
                      openNotes();
                    }
                  }
                />
              }
            </div>
            <Popup
              trigger={
                <div className="button-container">
                  {
                    !showInfo &&
                    <FlorenzButton
                      typeStyle={"secondaryWhite"}
                      size="s"
                      text={t("followUp.moreOptions")}
                      icon={"zaia-icono-dots-vertical"}
                      iconSize={"11px"}
                    />
                  }
                </div>
              }
              position={"top center"}
              keepTooltipInside
            >
              {
                (close) => {
                  return <S.PopUpPatientOptions>
                    <div className="header">
                      {t("globally.moreOptions")}
                    </div>
                    <div className="options-list">
                      <div className="option"
                        onClick={() => {
                          setShowInfo(true);
                          close();
                        }}
                      >
                        <div className="option__text">
                          {t("globally.morePatientInfo")}
                        </div>
                        <i className="option__icon icon zaia-i-person"></i>
                      </div>
                    </div>
                  </S.PopUpPatientOptions>
                }
              }
            </Popup>
            {/* <div className="button-container">
              <FlorenzButton
                typeStyle={"secondaryWhite"}
                size="s"
                text={"~Chat"}
                icon={"zaia-i-message-outline"}
                iconSize={"11px"}
                // onClick={() => closeModal()}
              />
            </div>
            <div className="button-container">
              <FlorenzButton
                typeStyle={"secondaryWhite"}
                size="s"
                text={"~More options"}
                icon={"zaia-icono-dots-vertical"}
                iconSize={"13px"}
                // onClick={() => closeModal()}
              />
            </div> */}
          </div>
        </div>
      </div>
    </S.ModalUserAiNavigator>
  );
};

// const ProgramsContainer = ({processes}) => {

//   const {t, i18n: { language }} = useTranslation("global");

//   return (
//     <S.ProgramsContainer>
//       <div className="title">{t("globally.programs")}</div>
//       <div className="programs-list">
//         {
//           processes.map((userToProcess) => {    
            
//             console.log("userToProcess", userToProcess.processStage?.stageName);
            
            
//             return (
//               <div className="program-box" key={userToProcess.id}>
//                 <div className="program-box__name">
//                   <i>{t("globally.program")}</i> {P.dataTranslation(userToProcess.process?.processName, language)}
//                 </div>
//                 <div className="program-box__status">
//                   {t("followUp.stage")} <b>{P.dataTranslation(userToProcess.processStage?.stageName, language)}</b>
//                 </div>
//               </div>
//             )                                 
//           })
//         }
//       </div>
//     </S.ProgramsContainer>
//   )
// }

export default ModalUserAiNavigator;
